import request from "../utils/request"

export function loginAdmin(data) {
  return request({ url: "/admin/auth/login", method: "post", data })
}

export function fetchCurrentAdmin() {
  return request({ url: "/admin/auth/me", method: "get" })
}

export function logoutAdmin() {
  return request({ url: "/admin/auth/logout", method: "post" })
}

export function changeAdminPassword(data) {
  return request({ url: "/admin/auth/change-password", method: "post", data })
}
